export const spotRequestConstants = {
    LOADING: 'SPOT_REQUEST_LOADING',
    UPDATE_VALUE: 'SPOT_REQUEST_UPDATE_VALUE',
    INITATE: 'SPOT_REQUEST_INITATE',
    STORE_FILE: 'SPOT_REQUEST_STORE_FILE',
    DELETE_FILE: 'SPOT_REQUEST_DELETE_FILE',
};